import { createFileRoute } from '@tanstack/react-router';

import { SearchPage } from '../modules/search/ui/pages/SearchPage';

export const Route = createFileRoute('/_authenticated/search')({
  component: SearchPage,
});
